import * as t from './action_types';

/**
 * @param {Boolean} expandAll
 */
export const setExpandAll = expandAll => ({
  type: t.SC_SET_EXPAND_ALL,
  payload: {
    expandAll,
  },
});

/**
 * @param {String} activeDate
 */
export const setActiveDate = activeDate => ({
  type: t.SC_SET_ACTIVE_DATE,
  payload: {
    activeDate,
  },
});

/**
 * @param {String} mode
 */
export const setScheduleMode = mode => ({
  type: t.SC_SET_MODE,
  payload: {
    mode,
  },
});

/**
 * @param {String} subject
 */
export const setScheduleSubject = subject => ({
  type: t.SC_SET_SUBJECT,
  payload: {
    subject,
  },
});

/**
 * @param {String} subject
 */
export const setDisplayedScheduleType = displayedScheduleType => ({
  type: t.SC_SET_DISPLAYED_SCHEDULE_TYPE,
  payload: {
    displayedScheduleType,
  },
});

/**
 * @param {Boolean} visbility
 */
export const setFiltersVisibility = filtersVisible => ({
  type: t.SC_SET_FILTERS_VISIBILITY,
  payload: {
    filtersVisible,
  },
});

/**
 * @param {String} key
 * @param {Boolean} value
 */
export const setFetchingFlag = (key, value) => ({
  type: t.SC_SET_FETCHING_FLAG,
  payload: {
    key,
    value,
  },
});

/**
 * @param {Array.<Number>} displayedTasksIds
 */
export const setDisplayedTasksIds = displayedTasksIds => ({
  type: t.SC_SET_DISPLAYED_TASKS_IDS,
  payload: {
    displayedTasksIds,
  },
});

/**
 * @param {String} query
 */
export const updateSearchQuery = searchQuery => ({
  type: t.SC_UPDATE_SEARCH_QUERY,
  payload: {
    searchQuery,
  },
});

/**
 * @param {Boolean} visibility
 */
export const setCalendarVisibility = visibility => ({
  type: t.SC_SET_CALENDAR_VISIBILITY,
  payload: {
    calendarVisible: visibility,
  },
});

/**
 * @param {String} type
 */
export const setScheduleType = type => ({
  type: t.SC_SET_TYPE,
  payload: {
    displayedScheduleType: type,
  },
});

/**
 * @param {Boolean} organizeFlag
 */
export const setOrganizeModeFlag = organizeFlag => ({
  type: t.SC_SET_ORGANIZE_MODE_FLAG,
  payload: {
    organizeModeFlag: organizeFlag,
  },
});

/**
 * @param {Boolean} organizeFlag
 */
export const setScheduleMountedFlag = mountedFlag => ({
  type: t.SC_SET_SCHEDULE_MOUNTED_FLAG,
  payload: {
    scheduleMounted: mountedFlag,
  },
});

/**
 * @param {String} sortingOption
 */
export const setSortingOption = sortingOption => ({
  type: t.SC_SET_SORTING_OPTION,
  payload: {
    sortingOption,
  },
});

/**
 *
 */
export const changeToPrevPage = totalRecords => ({
  type: t.SC_PAGINATION_PREV_PAGE,
  payload: {
    totalRecords,
  },
});

/**
 *
 */
export const changeToNextPage = totalRecords => ({
  type: t.SC_PAGINATION_NEXT_PAGE,
  payload: {
    totalRecords,
  },
});
